<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" label-width="150px" v-loading="loading">
        <el-form-item prop="oilTypeName" label="类型名称：">
          {{ formData.oilTypeName || "-" }}
        </el-form-item>

        <el-form-item prop="oilSpecs" label="规格：">
          {{ formData.oilSpecs || "-" }}
        </el-form-item>
        <el-form-item prop="ygUnitName" label="单位名称：">
          {{ formData.ygUnitName || "-" }}
        </el-form-item>

        <el-form-item prop="oilImg" label="图片：">
          <el-image
            v-if="formData.oilImg"
            style="width: 100px; height: 100px"
            :src="formData.oilImg"
            :preview-src-list="[formData.oilImg]"
          >
          </el-image>
          <span v-else>-</span>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>

export default {
  name: 'CpyCategoryDetail',
  data () {
    return {
      formData: {},
      dicList: [],
      loading: false
    }
  },
  created () {
    if (this.oilType) {
      this.loadData()
    }
  },
  computed: {
    oilType () {
      return this.$route.query.oilType
    }
  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.oiltabkManage.selectYgOilTypeByOilType, {
        params: { oilType: this.oilType }
      }).then(res => {
        this.formData = res || {}
      }).finally(() => {
        this.loading = false
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.form {
  margin-top: 30px;
  width: 450px;
}

.el-select {
  width: 100%;
}

.el-cascader {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}
</style>
